export var eventGraph;
(function (eventGraph) {
    eventGraph["PLOT"] = "plot";
    eventGraph["POINT"] = "point";
    eventGraph["LABEL"] = "label";
    eventGraph["CONNECT_LINE"] = "connectLine";
    eventGraph["LINE"] = "line";
    eventGraph["AREA"] = "area";
    eventGraph["NODE"] = "node";
    eventGraph["EDGE"] = "edge";
    eventGraph["AXIS_TITLE"] = "axisTitle";
    eventGraph["AXIS_LABEL"] = "axisLabel";
    eventGraph["AXIS_TICKS"] = "axisTicks";
    eventGraph["AXIS_LINE"] = "axisLine";
    eventGraph["AXIS_GRID"] = "axisGrid";
    eventGraph["LEGEND_TITLE"] = "legendTitle";
    eventGraph["LEGEND_ITEM"] = "legendItem";
    eventGraph["LEGETEN_ICON"] = "legendIcon";
    eventGraph["LEGEND_LABEL"] = "legendLabel";
    eventGraph["MARKLINE"] = "markLine";
    eventGraph["MARKLINE_LABEL"] = "markLineLabel";
    eventGraph["MARKLINE_ICON"] = "markLineIcon";
})(eventGraph || (eventGraph = {}));
/**
 * mouse event
 */
export var mouseEvents;
(function (mouseEvents) {
    mouseEvents["CLICK"] = "click";
    mouseEvents["DBL_CLICK"] = "dblclick";
    mouseEvents["MOUSE_MOVE"] = "mousemove";
    mouseEvents["MOUSE_OVER"] = "mouseover";
    mouseEvents["MOUSE_OUT"] = "mouseout";
    mouseEvents["MOUSE_ENTER"] = "mousenter";
    mouseEvents["MOUSE_LEAVE"] = "mouseleave";
    mouseEvents["TOUCH_MOVE"] = "touchmove";
    mouseEvents["TOUCH_START"] = " touchstart";
    mouseEvents["TOUCH_END"] = "touchend";
})(mouseEvents || (mouseEvents = {}));
/**
 * render event
 */
export var chartEvents;
(function (chartEvents) {
    chartEvents["BEFORE_RENDER"] = "beforerender";
    chartEvents["AFTER_RENDER"] = "afterrender";
})(chartEvents || (chartEvents = {}));
/**
 * plot events
 */
export var plotEvents;
(function (plotEvents) {
    plotEvents["PLOT_LEAVE"] = "plot:mouseleave";
    plotEvents["PLOT_MOVE"] = "plot:mousemove";
    plotEvents["PLOT_ENTER"] = "plot:mouseenter";
})(plotEvents || (plotEvents = {}));
/**
 * tooltip events
 */
export var tooltipEvents;
(function (tooltipEvents) {
    tooltipEvents["TOOLTIP_SHOW"] = "tooltip:show";
    tooltipEvents["TOOLTIP_SHOWN"] = "tooltip:shown";
    tooltipEvents["TOOLTIP_HIDE"] = "tooltip:hide";
    tooltipEvents["TOOLTIP_HIDDEN"] = "tooltip:hidden";
})(tooltipEvents || (tooltipEvents = {}));
